import {
  ENDORSEMENTS_LABELS,
  IEndorsements,
} from 'transfix-form/forms/CarrierFleetInformation/components/EndorsementsModal/types'
import { Maybe } from 'types/graphqlTypes'
import { TEndorsements } from '../types'

export const getEndorsementsLabels = (
  endorsements: Maybe<TEndorsements['endorsements']>
): string => {
  const endorsementsValues = endorsements ?? []
  const labels = endorsementsValues.map(
    endorsement => ENDORSEMENTS_LABELS[endorsement as IEndorsements] || endorsement
  )

  return labels.join(', ')
}
